/* eslint-disable max-len */
export const QUARA_FAQ_DATA = [
  {
    open: false,
    question: 'What are the minimum and maximum for device installment service?',
    answer: `The minimum is 4,000 SR and the maximum is 30,000 SR`,
    questionAr:
      'ما هو الحد الأدنى والحد الأقصى من التكلفة للإستفادة من خدمة تقسيط الجهاز ؟',
    answerAr: `الحد الأدنى هو 4000 ريال سعودي والحد الأقصى هو 30000 ريال سعودي`,
  },
  {
    open: false,
    question: 'How long does the approval process take?',
    answer: `The approval process takes 15 - 30 minutes, in case all documents are fully submitted.`,
    questionAr: 'كم من الوقت تستغرق عملية الموافقة ؟',
    answerAr: `تستغرق عملية الموافقة من 15 إلى 30 دقيقة، في حال تم تقديم جميع الوثائق المطلوبة بالكامل.`,
  },
  {
    open: false,
    question:
      'If my financing request is rejected by you, what is the required procedure by stc?',
    answer: `Accepting and rejecting finance applications is the responsibility of Quara Finance (i.e. stc bears no liability for any procedure regarding the financing eligibility).
`,
    questionAr:
      'في حال تم رفض طلب التمويل الخاص بي من قبلكم، فما هو الإجراء المطلوب من الجهة الخاضعة للعقد ؟',
    answerAr: `قبول طلبات التمويل ورفضها هو من مسؤولية شركة Quara Finance (أي أن الخاضع للعقد لا يتحمل أي مسؤولية عن أي إجراء يتعلق بأهلية التمويل).`,
  },
  {
    open: false,
    question:
      'Are replacement and return policies applied in the process of installment purchase?',
    answer: `Yes. All provisions and policies of replacement and return shall apply.
 `,
    questionAr: 'هل تطبق سياسات الاستبدال والإرجاع في عملية الشراء على أقساط ؟',
    answerAr: `
                نعم. تنطبق جميع أحكام وسياسات الاستبدال والإرجاع.

                  `,
  },
  {
    open: false,
    question:
      'Can I return the products purchased in installment and receive my cash back?',
    answer: `No, If you want to replace or return the devices purchased in installments, stc replacement and return policy shall apply.
`,
    questionAr: '',
    answerAr: ``,
  },
  {
    open: false,
    question:
      'Can I get more than installment service at sporadic times, if my purchases do not overpass the maximum?',
    answer: `Yes, provided that the period is not less than 3 months, and the installments of the previous contract were being regularly paid.
`,
    questionAr: '',
    answerAr: ``,
  },
  {
    open: false,
    question: 'How can I get installment service from Quara Finance?',
    answer: `You can complete the online application at Quara Finance website. You can also visit one of stc stores providing the service.  `,
    questionAr: '',
    answerAr: ``,
  },
  {
    open: false,
    question:
      'What are the branches that provide the installment service through Quara Finance?',
    answer: `Riyadh (Al-Suwaidi, Al Sharq, Al Shamal, King Fahad Road), Jeddah (Prince Sultan Road, AlSafa), Mecca (Al Shawkia), Dammam (Almajdouie, Al Shadi’), Maddina (Rawabi Qibaa), Jazan (Corniche “Main”), Khamis Mushait (Khamis Avenue).
`,
    questionAr: '',
    answerAr: ``,
  },
  {
    open: false,
    question:
      'What are the advantages of Takaful insurance’s service and the deduction rate?',
    answer: `The service provides Takaful insurance covering the remaining finance in case of death. The service shall not overpass the deduction ratios prescribed by SAMA.`,
    questionAr: '',
    answerAr: ``,
  },
];

export const TAMARA_FAQ_DATA = [
  {
    open: false,
    question: 'How will I receive my refund if I paid using Tamara?',
    answer: `
                    <p>All refunds will be issued once the original product in your return has been received by our team. Your refund will be processed to the original payment method. Refunds can take 5–10 business days to appear on your statement.&nbsp;&nbsp;</p><p>Payment by installments can be processed differently, depending on your payment schedule, how much you have paid before returning your order, and if you have requested a full or partial refund. Please note you may be asked to continue making payments.&nbsp;</p>
                    
                  `,
    questionAr: 'كيف يمكنني سترداد أموالي إذا كنت قد دفعت عن طريق تمارا؟',
    answerAr: `
    <p>سيتم إرسال جميع المبالغ المستردة بمجرد استلام المنتج الأصلي في عملية الإرجاع من قبل فريقنا. ستتم معالجة اموالك المستردة  بطريقة الدفع الأصلية. يمكن أن تستغرق المبالغ المستردة من 5 إلى 10 أيام عمل لتظهر في حسابك. يمكن معالجة عملية الدفع على أساس الأقساط بشكل مختلف، اعتمادًا على جدول الدفع الخاص بك، والمبلغ الذي دفعته قبل إعادة طلبك، وإذا كنت قد طلبت استردادًا كاملاً أو جزئيًا. يرجى ملاحظة أنه قد يُطلب منك مواصلة سداد المدفوعات.</p>
    
    `,
  },
  {
    open: false,
    question: 'How do I return a product purchased with Tamara?',
    answer: `
                    <p>Returning products purchased with Tamara must be done in accordance with Popsy's return policy.</p><p>Please, contact our team to receive your return label and send your order back to us.</p><p>All refunds will be issued once the original product has been received by our team. Your refund will be processed to the original payment method. Refunds can take 5–10 business days to appear on your statement. Payment by installments can be processed differently depending on your payment schedule, how much you have paid before returning your order, and if you have requested a full or partial refund. Please note you may be asked to continue making payments.</p>
                    
                  `,
    questionAr: 'كيف يمكنني إرجاع منتج قمت بشرائه عبر تمارا؟',
    answerAr: `
    <p>يجب أن تتم إعادة المنتجات المشتراة مع تمارا وفقًا لسياسة الإرجاع الخاصة ببوبسي. من فضلك، اتصل بفريقنا لتلقي ملصق الإرجاع الخاص بك وأرسل طلبك إلينا. سيتم تحويل جميع المبالغ المستردة بمجرد استلام المنتج الأصلي من قبل فريقنا. ستتم معالجة استردادك إلى طريقة الدفع الأصلية. يمكن أن تستغرق المبالغ المستردة من 5 إلى 10 أيام عمل لتظهر في حسابك. يمكن معالجة الدفع على الأقساط بشكل مختلف اعتمادًا على جدول الدفع الخاص بك، والمبلغ الذي دفعته قبل إعادة طلبك، وإذا كنت قد طلبت استردادًا كاملاً أو جزئيًا. يرجى ملاحظة أنه قد يُطلب منك مواصلة سداد المدفوعات.</p>
    `,
  },
  {
    open: false,
    question: 'What if I cannot complete a Tamara payment?',
    answer: `
                    <p>This could be due to one of the following reasons:</p><p>Tamara’s services to the store in question are temporarily deactivated</p><p>The store chose to go with one option and not the other</p><p>The order amount exceeded the limit for either of the options (see “<a href="https://support.tamara.co/hc/en-us/articles/360020365400">Tamara’s maximum/minimum purchase limits</a>”)</p>
                    
                  
`,
    questionAr: 'ماذا لو أني لا أستطيع مواصلة سداد المبلغ مع تمارا؟',
    answerAr: `
    <p>قد يكون هذا بسبب أحد الأسباب التالية: تم إلغاء تنشيط خدمات تمارا للمتجر المعني مؤقتًا، اختيار المتجر المتابعة مع خيار واحد وليس بآخر، تجاوز مبلغ الطلب الحد لأي من الخيارين (انظر «حدود الشراء القصوى/الدنيا لـ Tamara»)</p>
    `,
  },
  {
    open: false,
    question: 'How to pay with Tamara?',
    answer: `
                    <p>1. Select Tamara as your payment method on checkout.</p><p>2. Log in or sign up with your mobile number.</p><p>3. Verify your if it's your first order with Tamara</p><p>4. Complete your first payment to make your first purchase and pay the rest over time.</p>
                    
                
 `,
    questionAr: 'كيف يمكنني تسديد المبلغ مع تمارا؟',
    answerAr: `
           <p>1. اختر تمارا كطريقة الدفع عند الدفع.<br>2. قم بتسجيل الدخول أو إنشاء حساب باستخدام رقم هاتفك المحمول.<br>3. تحقق من طلبك الأول مع تمارا<br>4. أكمل الدفعة الأولى لإجراء أول عملية شراء لك وادفع الباقي بمرور الوقت.</p>

                  `,
  },
  {
    open: false,
    question: 'Why was my order declined on Tamara?',
    answer: `
                    <p>There could be several reasons, including but not limited to the following:</p><p>- Your card isn't activated or fit for e-commerce</p><p>- You have prior commitments to your bank/telecommunications company and/or are flagged by Simah/Al Etihad Credit Bureau (AECB)/Ci-Net.</p><p>- You have unpaid bills from Tamara</p><p>- Tamara's intricate risk system considers the value of your purchase too high.</p><p>- The value of the items you're trying to buy exceeds the allowed limit.</p><p>- If none of the above reasons apply to you, please try with a different card!</p>
                    
                      `,
    questionAr: 'لماذا تم إلغاء طلبي مع تمارا؟',
    answerAr: `
                    <p>قد تكون هناك عدة أسباب منها على سبيل المثال لا الحصر ما يلي:</p><p>- بطاقتك غير مفعلة أو مناسبة للعملية شراء إلكترونية</p><p> - لديك التزامات سابقة للبنك/شركة الاتصالات الخاصة بك و/أو تم الإبلاغ عنها من قبل Simah/Al Etihad Credit Bureau (AECB )/Ci-Net.</p><p>- لديك فواتير غير مدفوعة من Tamara</p><p>- يعتبر نظام المخاطر المعقد في Tamara قيمة شرائك عالية جدًا. </p><p>- قيمة العناصر التي تحاول شرائها تتجاوز الحد المسموح به. </p><p>- إذا لم ينطبق عليك أي من الأسباب المذكورة أعلاه، يرجى المحاولة ببطاقة مختلفة!</p>
                    
    `,
  },
];

export const TABBY_FAQ_DATA = [
  {
    open: false,
    question: 'How do I cancel or return my order?',
    answer: `
                    <p>Cancellation or refund will be according to Popsy policy. If you decide to cancel or return your order, contact the store directly.&nbsp;Refund will be made directly into your tabby account.</p>
                  `,
    questionAr: 'كيف يمكنني إلغاء أو إرجاع طلبي؟',
    answerAr: `
 <p>الإلغاء أو الإرجاع سوف يكون اتّباعًا لسياسة متجر بوبسي. إذا أردت أن تلغي أو ترجّع طلبيتك، تواصل مع المتجر مباشرة. وسيتم إعادة الأموال مباشرةً إلى حسابك في تابي.</p>
    `,
  },
  {
    open: false,
    question:
      'I canceled my order, why weren`t the related payments canceled from my account?',
    answer: `
               <p>On the Tabby app, if the status of the order is not changed to “Canceled”, please contact the store to resolve this issue. Once you cancel your order from the store, the order status will be changed in your account and the change will be affected by refunding the relevant payments, if any.</p>
                  `,
    questionAr: 'قمت بإلغاء طلبي، لماذا لم يتم إلغاء الدفعات المتعلقة بحسابي؟',
    answerAr: `
    <p>على تطبيق Tabby، إذا لم يتم تغيير حالة الطلب إلى ”ملغى“ يرجى التواصل مع المتجر لحل هذه المشكلة. بمجرد إلغاء طلبك من المتجر، سيتم تغيير حالة الطلب في حسابك وتنفيذ التغيير بإرجاع الدفعات المتعلقة، إن وجدت.</p>
    `,
  },
  {
    open: false,
    question: 'What is the limit available to me to spend with Tabby?',
    answer: `
                    <p>There is no set exchange limit for possible purchases with Tabby. However, approval of purchases may depend on the following:</p><p>Your previous obligation to make Tabby paymentsYour remaining balance and unpaid orders with TabbyPurchase value for your shopping cartOther factors that determine approval of your request that cannot be disclosed for privacy and security reasons.</p>
                    

                    `,
    questionAr: 'ماهو الحد المتاح لي للإنفاق مع تابي؟',
    answerAr: `<p>لا يوجد حد معين للصرف لعمليات الشراء مع Tabby. ولكن قد تعتمد الموافقة على عمليات الشراء على التالي:• التزامك السابق لتسديد مدفوعات Tabby• رصيدك المتبقي وطلباتك الغير مدفوعة مع Tabby• قيمة الشراء لعربة التسوق الخاصة بك• عوامل أخرى تحدد الموافقة على طلبك لا يمكن الإفصاح عنها لدواعي الخصوصية والأمان</p>      
    `,
  },
];

export const BASEETA_FAQ_DATA = [
  {
    open: false,
    question: 'How can l apply for any of Baseeta services?',
    answer: `
                  You can apply to any of our services online via our website or mobile App or by visiting one of our branches located inside eXtra stores or by calling us at 8003044434 
                  `,
    questionAr: ' كيف يمكنني التقديم على أي من خدمات بسيطة؟',
    answerAr: `
 يمكنك التقدم بطلب للحصول على أي من خدماتنا عبر الإنترنت من خلال موقعنا الإلكتروني أو تطبيق الهاتف المحمول أو بزيارة أحد فروعنا المتواجدة داخل متاجر إكسترا أو بالاتصال بنا على الرقم 8003044434.

    `,
  },
  {
    open: false,
    question: 'Are Baseeta services Shari’ah compliant ?',
    answer: `
                  Yes, all our financial services are Shari’ah compliant and approved by the Shari’ah board.

                  `,
    questionAr: ' هل خدمات بسيطة متوافقة مع الشريعة الإسلامية؟',
    answerAr: `
 نعم، جميع خدماتنا المالية متوافقة مع الشريعة الإسلامية ومعتمدة من قبل هيئة الشريعة.
    `,
  },
  {
    open: false,
    question: ' Are there any fees associated with using Baseeta?',
    answer: `
                  Baseeta may charge fees for certain types of transactions or account activities. Review the terms of service or contact the customer service support to better understand.

                  
`,
    questionAr: ' هل هناك أي رسوم مرتبطة باستخدام قاعدة البيانات؟',
    answerAr: `
   قد تفرض بسيطة رسومًا على أنواع معينة من المعاملات أو أنشطة الحساب. راجع شروط الخدمة أو اتصل بدعم خدمة العملاء لفهم ذلك بشكل أفضل.
      `,
  },
  {
    open: false,
    question: 'When is the installment due?',
    answer: `
                 The installments for personal finances and installment sales finance are due on the 1st of every month, and on the 22nd for the credit card.

                
 `,
    questionAr: ' متى موعد القسط؟',
    answerAr: `
          يتم استحقاق أقساط التمويل الشخصي تمويل المبيعات بالتقسيط في اليوم الأول من كل شهر، ويوم 22 بالنسبة لبطاقة الائتمان.

                  `,
  },
  {
    open: false,
    question: ' What are the maximum and minimum amounts for personal finance ?',
    answer: `
                  The minimum amount is SAR 10 000 and the maximum amount is SAR 250 000

                      `,
    questionAr: ' ما هو الحد الأقصى والحد الأدنى للمبالغ المخصصة للتمويل الشخصي؟',
    answerAr: `
            الحد الأدنى للمبلغ هو 10000 ريال سعودي والحد الأقصى هو 250000 ريال سعودي.
 
    `,
  },
];
